(function () {
    function onDocumentReady() {
        let elements = document.getElementsByName("gmaDomainUrl");
        if (elements && elements.length > 0) {
            elements.forEach(element => {
                let gmaDomainVarName = element.value;
                if (gmaDomainVarName) {
                    let value = eval(gmaDomainVarName);
                    if (value) {
                        element.value = value;
                    } else {
                        element.value = '';
                    }
                }
            });
        }
    }

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }
})();